/* Size and pin XCloud's instant-search panel to the search bar in use
   (4 Sept 2026; extended 27 Sept 2026 for v2.13 item 3).
   XCloud positions #cloud-search-results itself with an inline absolute
   transform and hard-codes a 550px width; assets/xcloud-instant-search.css
   overrides those from the custom properties set here on :root:
     --gv-xcloud-menu-width  the active form's width
     --gv-xcloud-menu-left   the form's left edge in the viewport
     --gv-xcloud-menu-top    the form's bottom edge in the viewport
   The stylesheet pins the desktop panel with position: fixed at that left
   and top, so the panel follows the sticky header (snippets/scroll-smoothing
   .liquid) and its compact .rr-stuck state (assets/rr-motion.js). Runs only
   when settings.xcloud_instant_search is on. sync() runs on focusin of a
   name=q field, on resize, on scroll (one measurement per animation frame),
   and whenever the header section's class list changes (rr-stuck on and
   off); window.rrSearch.xcloudSync (the theme's one search namespace, fix
   27 Sept 2026) lets assets/rr-search.js ask for a measurement after it
   opens the phone sheet or moves the panel. */
(function () {
  var root = document.documentElement;
  var scrollQueued = false;
  var headerObserved = false;
  /* 29 Sept 2026 (header fold 6n): the full header now scrolls in the page
     flow, so the form's bottom edge moved on every scroll frame and the
     three :root properties were rewritten each frame, restyling the whole
     page. Values are written only when they change, and scrolling only
     re-measures while the results panel is showing. */
  var last = {};
  function put(name, val) {
    if (last[name] === val) return;
    last[name] = val;
    root.style.setProperty(name, val);
  }
  function panelShows() {
    var p = document.getElementById('cloud-search-results');
    return !!(p && p.getClientRects().length && p.offsetHeight > 0);
  }

  function activeForm() {
    var el = document.activeElement;
    if (el && el.name === 'q' && el.form) return el.form;
    return document.querySelector('form.header__search-form') ||
      document.querySelector('[data-autocomplete-true] form');
  }

  function sync() {
    try {
      var form = activeForm();
      if (!form) return;
      var r = form.getBoundingClientRect();
      if (r.width > 0) {
        put('--gv-xcloud-menu-width', Math.round(r.width) + 'px');
        put('--gv-xcloud-menu-left', Math.round(r.left) + 'px');
        put('--gv-xcloud-menu-top', Math.round(r.bottom) + 'px');
      }
    } catch (e) {
      /* a detached form or a missing style object: leave the last values */
    }
  }

  function onScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    raf(function () {
      scrollQueued = false;
      if (panelShows()) sync();
    });
  }

  /* The header compacts when rr-motion.js toggles rr-stuck on the section,
     which moves the form's bottom edge without a scroll or resize event. */
  function watchHeader() {
    if (headerObserved || !window.MutationObserver) return;
    var header = document.querySelector('.header-section');
    if (!header) return;
    headerObserved = true;
    /* v7.1 motion review F10: the header class flips on every fold; measure
       only when the results panel is actually open, and in the next frame
       rather than inside the fold frame (rr-compact.js settled() re-syncs
       once the slide lands) */
    new MutationObserver(function () {
      if (!document.getElementById('cloud-search-results')) return;
      (window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); })(function () {
        if (panelShows()) sync();
      });
    }).observe(header, { attributes: true, attributeFilter: ['class'] });
  }

  /* Search page field (owner, 1 Oct 2026): while the results hang under a field
     outside the header (the /search page form), that form carries rr-xs-joined
     so its frame turns Raptor Green and runs into the panel's frame
     (xcloud-instant-search.css). The header has its own .is-open styling in
     rr-search.css. The panel is watched directly: XCloud swaps it inside one
     wrapper per query, and rr-x-hidden hides it (Escape). */
  var lastForm = null;
  // only the page's own field (inside <main>); the header, its popup and the
  // phone sheet all carry .search-form too but have their own styling
  function isHeaderForm(f) {
    return !(f && f.closest && f.closest('main'));
  }
  function markJoined() {
    var p = document.getElementById('cloud-search-results');
    var on = !!(lastForm && !isHeaderForm(lastForm) && p && !p.classList.contains('rr-x-hidden') && panelShows());
    var joined = document.querySelectorAll('form.rr-xs-joined');
    for (var i = 0; i < joined.length; i++) if (!on || joined[i] !== lastForm) joined[i].classList.remove('rr-xs-joined');
    if (on) lastForm.classList.add('rr-xs-joined');
  }
  var panelMo = null, watchedPanel = null, watchedWrap = null;
  function watchPanel() {
    var p = document.getElementById('cloud-search-results');
    if (!window.MutationObserver || !p || p === watchedPanel) { markJoined(); return; }
    if (!panelMo) panelMo = new MutationObserver(function () { watchPanel(); markJoined(); });
    panelMo.disconnect();
    watchedPanel = p;
    watchedWrap = p.parentNode;
    panelMo.observe(p, { attributes: true, attributeFilter: ['class', 'style'] });
    if (watchedWrap) panelMo.observe(watchedWrap, { childList: true });
    markJoined();
  }
  function onField(e) {
    var t = e.target;
    if (!t || t.name !== 'q' || !t.form) return;
    lastForm = t.form;
    // XCloud draws or swaps the panel after its request returns
    setTimeout(watchPanel, 400);
    setTimeout(watchPanel, 1200);
    setTimeout(watchPanel, 2500);
  }
  document.addEventListener('focusin', onField);
  document.addEventListener('input', onField);
  window.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || t.name !== 'q' || !t.form || isHeaderForm(t.form)) return;
    if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
      var p = document.getElementById('cloud-search-results');
      if (p) p.classList.add('rr-x-hidden');
    } else if (e.key && e.key.length === 1) {
      var q = document.getElementById('cloud-search-results');
      if (q) q.classList.remove('rr-x-hidden');
    }
    setTimeout(markJoined, 0);
  }, true);  // window capture: another script stops keydown before it reaches document (1 Oct 2026)
  document.addEventListener('click', function () { setTimeout(markJoined, 50); });

  function boot() {
    sync();
    watchHeader();
  }

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.name === 'q') sync();
  });
  /* the panel opens as the shopper types, possibly after a scroll since focus */
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'q') sync();
  });
  window.addEventListener('resize', sync);
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    headerObserved = false;
    boot();
  });
  window.rrSearch = window.rrSearch || {};
  window.rrSearch.xcloudSync = sync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
